export enum PDCFilterName {
    "AllFindings" = "AllFindings",
    "Confidence_51_Through_75" = "Confidence_51_Through_75",
    "Confidence_76_Through_90" = "Confidence_76_Through_90",
    "Confidence_91_Or_Greater" = "Confidence_91_Or_Greater",
}
